<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-form-item label="采购人员：" class="query-form-item">
                    <el-select v-model="query.developer_id" placeholder="请选择采购人员" size="mini"
                               style="width: 100px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option :label="item.full_name" :value="item.id" v-for="item in developerList"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="ID:" class="query-form-item">
                    <el-input style="width: 100px;" clearable v-model="query.id" placeholder="请输入ID"
                              size="mini"></el-input>
                </el-form-item>

                <el-form-item label="销售国家：" class="query-form-item" prop="state">
                    <el-select v-model="query.category_state" style="width: 100px;" size="mini" filterable>
                        <el-option v-for="item in $common.us_arr" :key="item.us" :label="item.title" :value="item.us"
                                   :disabled="item.disabled">
                            <div class="keywords_arr_div">
                                <icon-svg :icon-class="item.us.toUpperCase()"
                                          style="font-size: 24px;margin-right:5px;"></icon-svg>
                                <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{
                                        item.title
                                    }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类目：" class="query-form-item" prop="developer_id">
                    <el-select v-model="query.category_id" placeholder="请选择" size="mini" filterable
                               style="width: 100px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option :label="item.name" :value="item.id" v-for="item in filterCategoryList"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ASIN：" class="query-form-item">
                    <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入"
                              size="mini"></el-input>
                </el-form-item>

                <el-form-item label="是否有专利值:" class="query-form-item">
                    <el-select v-model="query.has_patent_value" placeholder="状态" size="mini" style="width: 100px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="有" :value="1"></el-option>
                        <el-option label="没有" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标品类型：" class="query-form-item">
                    <el-select v-model="query.standard_product_type" placeholder="标品类型" size="mini"
                               style="width: 110px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未录入" :value="-1"></el-option>
                        <el-option :label="item.name" :value="item.value"
                                   v-for="item in standardProductTypeArr"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选品原则：" class="query-form-item">
                    <el-select v-model="query.selection_principle" placeholder="选品原则" size="mini"
                               style="width: 100px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option :label="item.name" :value="item.value"
                                   v-for="item in selectionPrincipleList"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否季节性：" class="query-form-item">
                    <el-select v-model="query.is_seasonality" placeholder="季节性" size="mini" style="width: 100px;">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="季节：" class="query-form-item">
                    <el-select v-model="query.season" placeholder="请选择" size="mini" filterable style="width: 100px;">
                        <el-option :label="item.label" :value="item.value"
                                   v-for="item in $common.seasonArr"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题：">
                    <el-input style="width: 100px;" clearable v-model="query.title"
                              placeholder="请输入" size="mini"></el-input>
                </el-form-item>


                <el-form-item label="运输模式：" class="query-form-item">
                    <el-select v-model="query.deliver_mode" placeholder="请选择" size="mini" filterable
                               style="width: 100px;">
                        <el-option :label="item.label" :value="item.value"
                                   v-for="item in getDeliverModeArr"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="运费差：" class="query-form-item">
                    <el-input style="width: 90px;" clearable v-model="query.min_freight_difference"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 90px;" clearable v-model="query.max_freight_difference"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="重(g)：" class="query-form-item">
                    <el-input style="width: 90px;" clearable v-model="query.min_weight"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 90px;" clearable v-model="query.max_weight"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>
                <form-range-item :queryTemp="query" ref="formRangeItem"></form-range-item>
                <el-form-item label="在途可售数量" class="query-form-item">
                    <el-input style="width: 70px;" clearable v-model="query.min_sale_count"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 70px;" clearable v-model="query.max_sale_count"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>

                <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
            </el-form-item>

        </el-form>
        <div class="refreshDiv">
            <el-button size="mini" @click="refreshNum" type="primary">刷新在途可售数量</el-button>
        </div>

        <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  @selection-change="handleSelectionChange"
                  class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>
            <table-asin-column></table-asin-column>

            <el-table-column label="销售国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                            :icon-class="scope.row.category_state.toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="采购人员" width="120" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.developer_username }} <br/>
                        {{ scope.row.developer_full_name }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="是否符合利润" width="100" align="center">
                <template slot-scope="scope">
                    <div :style="{color: scope.row.is_conforming_profit == 1 ? 'green': 'red'}">
                        {{ scope.row.is_conforming_profit ? '是' : '否' }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="分配链接时间" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.assign_production_time }}</div>
                </template>
            </el-table-column>

            <production-asins :needUpdate="true" @close-callback="closeCllback" :viewType="'edit'"/>

            <el-table-column label="在途可售数量" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.sale_count }}</div>
                </template>
            </el-table-column>

            <el-table-column label="类目" min-width="360" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category }}</div>
                </template>
            </el-table-column>

<!--            <el-table-column label="选品原则" min-width="100" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    <div class="fixedHeight">{{ scope.row.selection_principle }}</div>-->
<!--                </template>-->
<!--            </el-table-column>-->

<!--            <el-table-column label="标品类型" min-width="100" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    <div class="fixedHeight">-->
<!--                        {{ scope.row.standard_product_type == -1 ? '未录入' : scope.row.standard_product_type }}-->
<!--                    </div>-->
<!--                </template>-->
<!--            </el-table-column>-->

            <el-table-column label="专利" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini">{{ scope.row.patent_value ? scope.row.patent_value : '-' }}
                    </el-button>
                    <br/><br/>
                    <el-button type="success" @click="downFile(scope.row.patent_file)" size="mini"
                               :disabled="!scope.row.patent_file">下载
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="标题" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.title }}</div>
                </template>
            </el-table-column>
            <el-table-column label="备注" align="center" :show-overflow-tooltip="true" width="220">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>
            <el-table-column label="销售价格" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.selling_price }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品链接" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.ali_href_link" type="primary" size="mini"
                               @click="jumpUrl(scope.row.ali_href_link)">跳转
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="1688产品价格" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_factory_price }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.ali_pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.ali_pic_url" v-else/>
                </template>
            </el-table-column>

            <el-table-column label="1688产品标题" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_title }}</div>
                </template>
            </el-table-column>


            <el-table-column label="退货率" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ parseFloat((scope.row.refund_rate || 0) * 100).toFixed(2) }}%</div>
                </template>
            </el-table-column>

            <el-table-column label="长(cm)*宽(cm)*高(cm)-重(g)" width="190" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.long }}*{{ scope.row.wide }}*{{
                            scope.row.height
                        }}-{{ scope.row.weight }}
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="运费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运费单价/kg" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_unit_price }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运输模式" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.deliver_mode }}</div>
                </template>
            </el-table-column>

            <el-table-column label="运费差" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_difference }}</div>
                </template>
            </el-table-column>

            <el-table-column label="平台佣金" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.platform_commission }}</div>
                </template>
            </el-table-column>
            <el-table-column label="亚马逊物流配送费" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.delivery_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="退货费用" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.refund_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Vat税费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.vat_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月仓储费" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月仓储费" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="美国旺季差额" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.us_peak_season_balance }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格(免税)" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月利润" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1-9月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月投资回报率" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{
                            scope.row['early_investment_return_rate'] ? accMul(scope.row['early_investment_return_rate'], 100) + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月利润" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月投资回报率" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{
                            scope.row['late_investment_return_rate'] ? accMul(scope.row['late_investment_return_rate'], 100) + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="利润率(含税)" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row['profit_rate'] ? accMul(scope.row['profit_rate'], 100) + '%' : '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="利润率(免税)" width="130" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row['profit_rate_no_tax'] ? accMul(scope.row['profit_rate_no_tax'], 100) + '%' : '-' }}
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="类目树" min-width="180" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category_tree }}</div>
                </template>
            </el-table-column>
            <el-table-column width="110" align="center" label="父asin">
                <template slot-scope="scope">
                    <span>{{ scope.row.parent_asin }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上架时间" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.listed_since }}</div>
                </template>
            </el-table-column>

            <el-table-column label="品牌" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.brand }}</div>
                </template>
            </el-table-column>
            <el-table-column label="评分" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rating }}</div>
                </template>
            </el-table-column>

            <el-table-column label="评论数" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rating_count }}</div>
                </template>
            </el-table-column>
            <el-table-column label="是否季节性" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.is_seasonality == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="季节" width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.season }}</div>
                </template>
            </el-table-column>

            <el-table-column label="采购完成时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.assign_developer_finish_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="规格包装" width="140" align="center">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="updateSpecificationPackage(scope.row)">查看</el-button>
                </template>
            </el-table-column>


            <el-table-column label="操作" width="260" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="operateFunc(scope.row, 1)">
                        操作
                    </el-button>
                    <el-button type="danger" size="mini" @click="unassignFunc(scope.row)">
                        分配人员
                    </el-button>
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="detailFunc(scope.row)">
                        详情
                    </el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <detail-preview ref="detailPreview"></detail-preview>
        <updatePatent ref="updatePatentDom" @close-callback="closeCllback"></updatePatent>
        <select-user-modal ref="selectUser" @close-callback="closeCllback"></select-user-modal>
        <addBid
            :visible="showAddRecord"
            :title="editType === 0 ?'添加爬取排名Asin任务' : '成本分析操作'"
            :copyData="copyData"
            :editType='editType'
            @close-callback="closeCllback"
            @refreshList="refreshList"
        ></addBid>
        <specification-package-modal ref="specificationPackageModal"
                                     @close-callback="closeCllback"></specification-package-modal>
        <!--        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息"-->
        <!--                   v-if="errorInfoShow"-->
        <!--                   :visible.sync="errorInfoShow">-->
        <!--            <span style="color: red">错误内容：</span>-->
        <!--            <span>{{ errorMsg }}</span>-->
        <!--            <span slot="footer" class="dialog-footer">-->
        <!--				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>-->
        <!--			</span>-->
        <!--        </el-dialog>-->
        <!--        <basic-configuration-data :visible="showBasicConfigDataModal" v-if="showBasicConfigDataModal"-->
        <!--                                  @close-callback="showBasicConfigDataModal=false"></basic-configuration-data>-->
        <!--        <categoryList :visible="showCategoryList" v-if="showCategoryList"-->
        <!--                      @close-callback="showCategoryList=false"></categoryList>-->
        <!--        <addParse :visible="showAddParseModal" v-if="showAddParseModal" @close-callback="closeCllback"></addParse>-->
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {downloadFileUrl} from '@/utils/method'
import ChildInfoModal from '@/views/costAnalysisOne/childInfoModal.vue'
import DetailPreview from './depend/detailPreview.vue'
import updatePatent from '../costAnalysis/components/updatePatent'
import selectUserModal from '@/views/linkProduction/depend/selectUserModal.vue'
import ProductionAsins from '@/components/common/productionAsins.vue'
import addBid from './depend/addBid.vue'
import SpecificationPackageModal from '@/views/costAnalysis/components/specificationPackageModal.vue'

let timer = null
export default {
    name: 'myChoice',
    components: {
        SpecificationPackageModal,
        ProductionAsins,
        selectUserModal,
        DetailPreview,
        ChildInfoModal,
        updatePatent,
        addBid,
    },
    data() {
        return {
            selectionPrincipleList: [],
            standardProductTypeArr: [
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
            categoryList: [],
            rootCategoryList: [],
            usList: [],
            ukList: [],
            deList: [],
            imgStatusList: [
                {name: '全部', value: undefined},
                {name: '搜索不到图片', value: 1},
                {name: '暂无图片', value: 2},
                {name: '有图片', value: 3},
            ],
            isFold: true,
            editType: 0,
            copyData: {},
            manualRootShow: false,
            showBasicConfigDataModal: false,
            showAddParseModal: false,
            showCategoryList: false,
            manualRootList: [],
            showAddRecord: false,
            currentId: '',
            tableHeight: null,
            errorMsg: '',
            errorInfoShow: false,
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
            typeArr: [{
                index: 1,
                title: '广告层面'
            },
                {
                    index: 2,
                    title: '逻辑层面'
                }
            ],
            query: {
                page: 1,
                limit: 10,
                total: 0,
            },
            developerList: [],
            record_id: 0,
            activeName: 'antiInternal',
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            updateData: {},
            childInfo: {},
            multipleSelection: [],
        }
    },
    mounted() {
        this.getCategoryList()
        this.getList()
        this.tableHeight =
            window.innerHeight - 178 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        },
        'query.category_state': {
            handler(val) {
                this.filterCategoryList = ['', undefined, null].includes(val) ? this.categoryList : this.categoryList.filter(item => {
                    if (item.name.indexOf(`${val}-`) !== -1) {
                        return item
                    }
                })
                this.getDeliverModeArr = ['', undefined, null].includes(val) ? this.$common.deliverModeArr : this.$common.deliverModeArr.filter(item => item.nation == val || item.value == '')
                this.$set(this.query, 'category_id', '')
                this.$set(this.query, 'deliver_mode', '')
            },
            deep: true,
            immediate: true
        },
        categoryList: {
            handler() {
                const val = this.query.category_state
                this.filterCategoryList = ['', undefined, null].includes(val) ? this.categoryList : this.categoryList.filter(item => {
                    if (item.name.indexOf(`${val}-`) !== -1) {
                        return item
                    }
                })
            },
            deep: true,
        }
    },
    destroyed() {
        clearInterval(timer)
    },
    methods: {
        refreshNum(){
            api.crontab_refresh_waiting_allocate_asin_sale_count().then(res => {
                this.getList()
                this.$message.success('刷新成功')
            })
        },
        uploadPatentFile(data) {
            this.$refs.updatePatentDom.openModal(2, data)
        },
        updateVal(data) {
            this.$refs.updatePatentDom.openModal(1, data)
        },
        getCategoryList() {
            api.cost_analysis_selfbuild_get_selection_principle().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.selectionPrincipleList = (res.data || []).map(item => {
                        return {name: item, value: item}
                    })
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            })

            api.manager_index_get_category_message().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.categoryList = res.data || []
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })

            api.operation_index_get_developer_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.developerList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },

        detailFunc(data) {
            this.$refs.detailPreview.visible = true
            this.$refs.detailPreview.title = '详情展示'
            this.$refs.detailPreview.formData = data
            this.$refs.detailPreview.funcType = 1
        },
        // 分配人员
        unassignFunc(data) {
            this.$refs.selectUser.openModal(data)
        },
        // 操作
        operateFunc(data, type) {
            let tempDate = JSON.parse(JSON.stringify(data))
            tempDate.is_seasonality = tempDate.is_seasonality === 1 ? true : false
            this.editType = type
            this.copyData = tempDate
            this.showAddRecord = true
        },
        // 采购
        purchaseFunc(data) {
            api.cost_analysis_personal_add_to_purchase_list({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message)
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        },
        // 关闭弹窗
        goBackList() {
            this.query = {
                asin: '',
                page: 1,
                limit: 10,
                total: 0,
            }
            this.list = []
            this.$emit('goBackList')
        },
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            arr = Array.from(new Set(arr))
            this.multipleSelection = arr
        },
        seeUrl(row) {
            this.childInfo.title = '1688链接'
            this.childInfo.info = row.href_link
            this.ctrl.childInfoVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.href_link, '_blank')
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
        copyDataFunc(data, type) {
            this.showAddRecord = true
            let tempDate = JSON.parse(JSON.stringify(data))
            tempDate.is_peak_season = tempDate.is_peak_season == 1 ? true : false
            tempDate.is_seasonality = tempDate.is_seasonality == 1 ? true : false
            this.editType = type
            this.copyData = tempDate
        },
        delete_records(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.variety_cost_control_analysis_delete({ids: [data.id]}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.parsing_err_msg
        },
        showManualRoot(info) {
            this.manualRootShow = true
            this.manualRootList = info
        },
        getList() {
            this.loading = true
            const tempQuery = this.$refs.formRangeItem.handleQueryData()
            api.producer_personal_waiting_allocate_production_list(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    let responseList = res.data.list || []
                    responseList = responseList.map(item=>{
                        item.production_asins = JSON.parse(item.production_asins || {})
                        return item
                    })
                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        clickRowHandle(row, column) {
            let update = false
            if (['标题', '类目树', '子类目', '1688产品标题', '颜色', '备注'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '1688产品标题') {
                    info = row.ali_title
                } else if (column.label == '备注') {
                    info = row.remark
                    update = true
                }
                this.childInfo.id = row.id
                this.childInfo.info = info
                this.childInfo.update = update
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                limit: 10,
                total: 0,
            }
            this.getList()
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        updateSpecificationPackage(data) {
            this.$refs.specificationPackageModal.openModal(data)
        },

        // 关闭弹窗回调
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        refreshList() {
            this.getList()
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.refreshDiv {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.redTxt {
    color: red;
    font-weight: bold;
}

.fixedHeight {
    height: 50px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
